import axios from "../axios";

const api = {
  getModels(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/multimodal-transportations`, config).then(({ data }) => data);
  },

  createModel({ data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/multimodal-transportations`, data, headers)
      .then(({ data }) => data);
  },

  updateModel({ id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`/multimodal-transportations/${id}`, data, headers)
      .then(({ data }) => data);
  },

  deleteModel({ id }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/multimodal-transportations/${id}`, headers)
      .then(({ data }) => data);
  },

  getMultimodalTransportationItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/multimodal-transportations/${params.questionnaireId}/items`,
      config).then(({ data }) => data);
  },

  addMultimodalTransportationItems({ modelId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/multimodal-transportations/${modelId}/items`, data, headers)
      .then(({ data }) => data);
  },

  updateMultimodalTransportationItem({ modelId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/multimodal-transportations/${modelId}/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteMultimodalTransportationItem({ modelId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/multimodal-transportations/${modelId}/items/${recordId}`, headers)
      .then(({ data }) => data);
  }
};

export default api;